import React from 'react';
import AsyncComponent from '../../components/AsyncComponent';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';

import AlertsService from '../../services/AlertsService';

import Cities from '../../data/Cities';
import i18n from '../../i18n';

import { withStyles } from 'tss-react/mui';
import './styles.scss';

class SingleAlert extends AsyncComponent {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      alertNotFound: false,
    };

    this._initialize();
  }

  render() {
    if (this.state.alertNotFound) {
      return (
        <div>
          <h1>{i18n.t('404Title')}</h1>
          <p>{i18n.t('404Content')}</p>
        </div>
      );
    }

    return (
      <>
        {this._renderAlert()}
      </>
    );
  }

  async _initialize() {
    await this._getAlertTypes();
    await this._getAlert();
  }

  async _getAlertTypes() {
    this.alertTypes = await AlertsService.getAlertTypes();
  }

  async _getAlert() {
    const alert = await AlertsService.getAlert(this.props.params.id);
    if (!alert) {
      this.setState({ alertNotFound: true });
      return;
    }

    alert.cityNames = await Cities.getInstance().getCitiesName(alert.city_ids);
    await this.setStateAsync({ alert: alert });
  }

  _renderAlert() {
    const { classes } = this.props;
    const alert = this.state.alert;

    if (!alert) {
      return null;
    }

    return (
      <Grid size={{ xs: 12, sm: 12, md: 12 }}>
        <div className={classes.alertItem}>
          <Typography variant="h6">{alert.title}</Typography>
          <Typography variant="body1">{this.alertTypes[alert.type] && this.alertTypes[alert.type][i18n.getLanguageEnabled()] ? this.alertTypes[alert.type][i18n.getLanguageEnabled()] : alert.type}</Typography>
          <Typography variant="body1">{alert.cityNames}</Typography>
          <Typography variant="body1">{moment(alert.time_to_send ? alert.time_to_send : alert.created_at).format('🕑 YYYY-MM-DD - HH:mm')}</Typography>
          {this._renderAlertImage()}
          <Typography variant="body1">{alert.content}</Typography>
          {this._renderMoreInformationButton()}
        </div>
      </Grid>
    );
  }

  _renderAlertImage() {
    const { classes } = this.props;
    const alert = this.state.alert;

    if (!alert || !alert.picture_url) {
      return null;
    }

    return (
      <div className={classes.alertImageContainer}>
        <img src={alert.picture_url} alt="Alert" className={classes.alertImage} />
      </div>
    );
  }

  _renderMoreInformationButton() {
    const { classes } = this.props;
    const alert = this.state.alert;

    if (!alert || !alert.more_information_url) {
      return null;
    }

    return (
      <Box mt={2} className={classes.moreInformationButtonContainer}>
        <Link href={alert.more_information_url} target="_blank" rel="noopener noreferrer">
          {i18n.t('moreDetails')}
        </Link>
      </Box>
    );
  }
}

const styles = _theme => ({
  alertImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20px 0',
  },
  alertImage: {
    maxWidth: '50%',
    height: 'auto',
  },
  alertItem: {
    margin: '20px',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
  },
  moreInformationButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});

function SingleAlertScene(props) {
  const params = useParams();

  return (
    <SingleAlert params={params} {...props} />
  );
}

export default withStyles(SingleAlertScene, styles);;
